<template>
  <b-button variant=link @click='clone' :disabled='busy'>
    <font-awesome-icon v-if='busy' icon='fa-solid fa-spinner' class='fa-spin' />
    <font-awesome-icon v-else icon='fa-light fa-clone'/>
    <span>Clone Order</span>
  </b-button>
</template>


<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'CloneOrderLink',
  props: {
    action_block: {
      required: false,
      type: Function
    }
  },
  data () {
    return{
      busy: false,
    }
  },
  computed: {
    ...mapState( 'order_details', [
      'order'
    ]),
  },
  methods: {
    ...mapActions( 'orders', {
      clone_order: 'clone_order'
    }),
    clone () {
      if ( !this.busy ) {
        if ( ( this.action_block ?? null ) && this.action_block() ) {
          return;
        }
        this.busy = true;
        const busy_id = this.$jjToast({
          type: 'busy',
          title: 'Loading',
          content: 'Cloning order',
        });
        this.clone_order( this.order.id )
          .catch( () => {
            this.$jjToast({
              type: 'error',
              title: 'Error',
              content: `Failed to clone order`,
            });
          })
          .finally( () => {
            this.busy = false;
            this.$bvToast.hide( busy_id );
          });
      }
    }
  }
}
</script>